"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
/**
 * Set Status/failedReason of refund order payment
 * @param event
 * @param prevState
 */
function default_1(event, prevState) {
    const order = prevState;
    const { paymentTransactionRef, failedReason, isSuccess } = event;
    const isRefunded = isSuccess === 'true' ? true : false;
    const payment = order.payments.find(p => p.paymentTransactionRef === paymentTransactionRef);
    if (payment) {
        payment.status = isRefunded
            ? domain_1.OrderPaymentStatus.SENT_FOR_REFUND
            : domain_1.OrderPaymentStatus.REFUND_FAILED;
        payment.failedReason = !isRefunded ? failedReason : '';
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=refundOrderUpdate.js.map